const mainButtonStyles = {
  width: '130px',
  height: '43px',
  textTransform: 'uppercase',
  fontSize: '17px',
  border: 'none',
  borderRadius: '0px',
};

export const buttons = {
  icon: {
    width: 'fit-content',
    height: 'fit-content',
    padding: '2px',

    '&:focus': {
      backgroundColor: 'bg.200',
      borderRadius: '100%',
      transition: 'background-color 0.2s ease',
    },
  },

  primary: {
    ...mainButtonStyles,
    backgroundColor: 'primary',
    color: 'white',

    '&:disabled': {
      backgroundColor: 'primary-disabled',
    },
  },

  secondary: {
    ...mainButtonStyles,
    backgroundColor: 'bg.800',
    color: 'white',

    '&:hover': {
      color: 'text-primary',
      backgroundColor: 'transparent',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'bg.800',
    },
  },

  text: {
    width: '100%',
    textTransform: 'uppercase',
    color: 'primary',
    backgroundColor: 'transparent',
    fontSize: '24px',
    fontWeight: 'bold',
    border: 'none',

    '&:focus': {
      textDecoration: 'underline',
    },

    inline: {
      fontSize: '14px',
      color: 'text-primary',
      backgroundColor: 'transparent',
      fontWeight: 'bold',
      border: 'none',
      textTransform: 'capitalize',

      '&:focus': {
        textDecoration: 'underline',
      },
    },
  },
};
